import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ServiceRequestResponseTypeUtil } from 'src/app/shared/utils/service-request-response.utils';
import { GeneralHistoryModel, HistoryClient, RegisteredSignal, ServiceRequestResponseTypes } from 'src/app/web-api-client';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-signal-details',
  templateUrl: './signal-details.component.html',
  styleUrl: './signal-details.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class SignalDetailsComponent implements OnInit {
  @Input() registeredSignal: RegisteredSignal = null;

  public onClose = new Subject<void>();

  public loading = true;
  public showAttachedMediaSection = false;

  public phoneNumberUtil = PhoneNumberUtil.getInstance();
  public generalHistory: GeneralHistoryModel[] = [];

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly historyClient: HistoryClient,
    private toastr: ToastrService, 
    private readonly chd:ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {

    this.historyClient.getVikSignalHistory(this.registeredSignal.id).subscribe(r => {
      this.generalHistory = r;
      this.loading = false;
      this.chd.detectChanges();
    })

  }

  public closeModal() {
    this.activeModal.close();
    this.onClose.next();
  }

  get signalRequestorNames(): string {
    const firstName = this.registeredSignal?.signalRequestor?.name || '';
    const middleName = this.registeredSignal?.signalRequestor?.middleName || '';
    const lastName = this.registeredSignal?.signalRequestor?.fammily || '';

    return `${firstName} ${middleName} ${lastName}`;
  }

  get phoneNumber(): string {
    return this.registeredSignal.signalRequestor.phoneNumber || 'n/a';
  }

  get emailAddress(): string {
    return this.registeredSignal.signalRequestor.email || 'n/a';
  }

  get responseType(): string {
    const responseType = this.registeredSignal?.responseType || ServiceRequestResponseTypes.None;
    return ServiceRequestResponseTypeUtil.getCyrilicLabel(responseType);
  }

  get signalId(): string {
    return this.registeredSignal && this.registeredSignal.id ? this.registeredSignal.id .toString():'n/a';
  }

  get signalTitle(): string {
    return this.registeredSignal.title || 'n/a';
  }

  get signalDescription(): string {
    return this.registeredSignal.description || 'n/a';
  }

  get signalDate(): string {
    if(this.registeredSignal.when === null || this.registeredSignal.when === undefined) return 'n/a';

    return this.datePipe.transform(this.registeredSignal.when, 'dd MMMM yyyy, HH:mm', 'bg-BG');
  }

  get emergencyType(): string {
    return this.registeredSignal.tipAvaria.title || 'n/a';
  }

  get status(): string {
    return this.registeredSignal.signalStatus.title || 'n/a';
  }

  get workingGroup(): string {
    return this.registeredSignal.workingGroups?.title || 'n/a';
  }

  get workingGroupManager(): string {
    if (!this.registeredSignal.workingGroups) {
      return 'n/a';
    }

    const manager = this.registeredSignal.workingGroups.manager;
    return manager
      ? `${manager.firstName} ${manager.fammilyName}`
      : "n/a";
  }

  get checkoutDate(): string {
    if(this.registeredSignal.checkoutWhen === null || this.registeredSignal.checkoutWhen === undefined) return 'n/a';

    return this.datePipe.transform(this.registeredSignal.checkoutWhen, 'dd MMMM yyyy, HH:mm', 'bg-BG');
  }

  get checkoutNote(): string {
    return this.registeredSignal.checkoutAdittionalInfo || 'n/a';
  }

  get incidentLocation(): google.maps.LatLngLiteral {
    return {
      lat: +this.registeredSignal.latitude,
      lng: +this.registeredSignal.longitude
    }
  }
}
